import React from "react";
import { Button } from "@jugl-web/ui-kit";
import { useTranslations } from "@jugl-web/utils";
import { useNavigation } from "@web-src/modules/navigation/hooks/useNavigation";
import { useSubscriptionV2 } from "@web-src/modules/cx/providers/SubscriptionV2Provider";
import { useUserRole } from "@web-src/modules/common/hooks/useUserRole";
import { ReactComponent as PricingIcon } from "./assets/pricing.svg";
import { ReactComponent as InfoIcon } from "./assets/info.svg";

export const CanceledSubscriptionSection: React.FC = () => {
  const { t } = useTranslations();
  const { navigateToPage } = useNavigation();
  const { isAdmin } = useUserRole();
  const { isSubscriptionCanceled } = useSubscriptionV2();

  if (!isSubscriptionCanceled || !isAdmin) return null;
  return (
    <div className="bg-grey-100 flex flex-col gap-6 rounded-xl p-5">
      <div className="flex items-center gap-3">
        <InfoIcon className="shrink-0" />
        <span className="text-dark font-secondary text-sm leading-[21px]">
          {t({
            id: "cx-ai-agents-page.canceled-subscription-message",
            defaultMessage:
              "Subscription is Canceled. Manage Subscription to renew AI Agent usage",
          })}
        </span>
      </div>
      <Button
        iconEnd={<PricingIcon />}
        onClick={() => navigateToPage("cxWorkspacePlans")}
        variant="secondary"
      >
        {t({
          id: "cx-ai-agents-page.canceled-subscription.manage-subscription-btn",
          defaultMessage: "Manage Subscription",
        })}
      </Button>
    </div>
  );
};
